module.exports = __webpack_public_path__ + "static/media/commission.e3e05f7f.png";